import React from 'react';
import {Stack, Typography} from '@mui/material';
import PIRCreateIcrDialog from '../../PIR/page/PIRCreateIcrDialog';

/**
 * Header for the ICR list page. Mirrors PIRHeader behaviour: title + create dialog action.
 */
export default function IcrHeader({
                                      title = 'Intelligence Collection Requests',
                                      createLabel = 'Create ICR',
                                      pirId = null
                                  }) {
    return (
        <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'} p={2}>
            <Typography variant={'h5'}>{title}</Typography>
            <Stack direction={'row'} spacing={1}>
                <PIRCreateIcrDialog pirId={pirId}/>
            </Stack>
        </Stack>
    );
}

